let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("bGizp")).then(() => parcelRequire('6nxda'));